import { PlayerProfileContext } from '@library/components/player/PlayerProfile';
import { useContext } from 'react';

export interface PlayerSubheaderProps {
  className?: string;
}

export const PlayerSubheader = ({
  className = 'text-soClean-180 hidden pl-1.5 2xl:flex'
}: PlayerSubheaderProps) => {
  const { subheader } = useContext(PlayerProfileContext);

  return <span className={className}>{subheader}</span>;
};
